import $ from 'jquery';

export default class {
	constructor(options = {}) {
		const defaults = {
			el: '.js-info-message',
			dom: {
				closeButton: '.js-info-message-close'
			},
			classes: {
				visible: 'visible'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = this.options.el instanceof $ ? this.options.el : $(this.options.el);
		this.hideTimeout = this.$el.data('hide-timeout') * 1000 || false;
		this.localHideDate = Number(window.localStorage.yCookieMessageHideDate);
		this.localMessageViewed = window.localStorage.yCookieMessageViewed;
	}

	getDom() {
		this.$closeButton = this.$el.find(this.options.dom.closeButton);

		return this;
	}

	close() {
		this.$el.removeClass(this.options.classes.visible);
		window.localStorage.removeItem('yCookieMessageHideDate');
		window.localStorage.setItem('yCookieMessageViewed', 'true');
	}

	checkExpireTime() {
		if (this.localMessageViewed || (!this.hideTimeout && !this.localHideDate)) {
			return;
		}

		if (this.localHideDate) {
			const hideDelay = this.localHideDate - Date.now();

			if (hideDelay <= 0) {
				window.localStorage.removeItem('yCookieMessageHideDate');
				window.localStorage.setItem('yCookieMessageViewed', 'true');

				return;
			}

			this.$el.addClass(this.options.classes.visible);
			setTimeout(this.close.bind(this), hideDelay);

			return;
		}

		window.localStorage.setItem('yCookieMessageHideDate', `${Date.now() + this.hideTimeout}`);
		this.$el.addClass(this.options.classes.visible);
		setTimeout(this.close.bind(this), this.hideTimeout);
	}

	init() {
		this.checkExpireTime();
		this.$closeButton.on('click', this.close.bind(this));

		return this;
	}


	render() {
		if (this.$el.length) {
			this.getDom().init();
		}

		return this;
	}
}



// WEBPACK FOOTER //
// ./app/blocks/infomessage/infomessage.js